import './App.css';
import Currency from './components/Currency';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', justifyItems: 'center', alignItems: 'center'}}>
      <Currency />
    </div>
  );
}

export default App;
